import { isEqual } from 'lodash';

import { siteIds } from '../constants';

import InstrumentariumEESettings from './instrumentarium-ee/settings';
import InstrumentariumFISettings from './instrumentarium/settings';
import KeopsSettings from './keops/settings';
import NissenSettings from './nissen/settings';
import TerveystaloSettings from './terveystalo/settings';

const getOverrideSiteId = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('channel') === 'terveystalo' ? 'terveystalo' : null;
};

export const siteId = getOverrideSiteId() || process.env.REACT_APP_BRAND;

export const settings = (() => {
  if (isEqual(siteId, siteIds.InstrumentariumEE)) {
    return InstrumentariumEESettings;
  }
  if (isEqual(siteId, siteIds.InstrumentariumFI)) {
    return InstrumentariumFISettings;
  }
  if (isEqual(siteId, siteIds.Keops)) {
    return KeopsSettings;
  }
  if (isEqual(siteId, siteIds.Nissen)) {
    return NissenSettings;
  }
  if (isEqual(siteId, siteIds.Terveystalo)) {
    return TerveystaloSettings;
  }
  return {};
})();
